import Vue from "vue";
import Router from "vue-router";
import About from "./views/About.vue";
import HitAndBlow from "./views/HitAndBlow.vue";
import CsvParser from "./views/CsvParser.vue";
import Steam from "./views/Steam.vue";
import Maps from "./views/Maps.vue";
import Borderlands from "./views/Borderlands.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "about",
      component: About,
    },
    {
      path: "/hitandblow",
      name: "hitandblow",
      component: HitAndBlow,
    },
    {
      path: "/csvparser",
      name: "csvparser",
      component: CsvParser,
    },
    {
      path: "/steam",
      name: "steam",
      component: Steam,
    },
    {
      path: "/maps",
      name: "maps",
      component: Maps,
    },
    {
      path: "/borderlands",
      name: "borderlands",
      component: Borderlands,
    },
  ],
});
